import type { MouseEvent } from 'react';

interface OpenAppProps {
  urlToOpen?: string | null;
  openHereClicked?: (e: MouseEvent) => void;
  mode?: 'auth' | 'open-doc'; // default to 'auth'
}

export const OpenInAppPage = ({
  urlToOpen: _urlToOpen,
  openHereClicked: _openHereClicked,
  mode: _mode = 'auth',
}: OpenAppProps) => {
  return null;
};
